module.exports = __webpack_public_path__ + "media/images/logo-415-9184e553267462837831361d2732ed74.jpg";